/**
 * Generate user profile for storing in store
 * @param {object} response
 * @param {bool} token
 */
export function generateUserProfile(response, token = false) {
  return {
    token: response.data.token || localStorage.getItem('token'),
    company_id: response.data.user.company_id,
    id: response.data.user.id,
    email: response.data.user.email,
    first_name: response.data.user.first_name,
    last_name: response.data.user.last_name,
    phone: response.data.user.phone,
    profile_photo_url: response.data.user.profile_photo_url,
    contract_url: response.data.user.contract_url,
    agreement_url: response.data.user.agreement_url,
    color: response.data.user.color,
    job_description_url: response.data.user.job_description_url,
    roles: response.data.user.roles.map(r => ({
      id: r.id,
      display_name: r.display_name,
      name: r.name,
    })),
    project: response.data.user.project[0],
    projects: response.data.user.projects,
  }
}


// WEBPACK FOOTER //
// ./src/helpers/user.js